import React, { useState, useEffect } from 'react';
import { Row, Col, Select, message } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';

import { webServiceProvider } from 'shared';

const { Option } = Select;

const SelectRow = styled(Row)``;

const StyledSelect = styled(Select)`
  & .ant-select-selection {
    border: none;
  }
  &:hover {
    border: 1px solid #d9d9d9;
    border-radius: 3px;
  }
`;
const Container = styled.div`
  margin: 10px;
`;

const NewName = styled.div`
  color: blue;
`;

function C3Select(props) {
  const {
    title,
    type,
    value,
    handleSelect,
    handleAdd,
    handleDelete,
    items = [],
    shopId = 123456789,
  } = props;

  const [options, setOptions] = useState(items);
  const [filteredOptions, setFilteredOptions] = useState(items);
  const [inputValue, setInputValue] = useState(value);
  const [showSaveOption, setShowSaveOption] = useState(false);

  useEffect(() => {
    setFilteredOptions(items);
  }, [items]);

  const saveOption = async (newOption) => {
    try {
      const res = await webServiceProvider.post('v1/vmrs-diagnosis', {
        shopId,
        type,
        value: newOption,
      });

      setInputValue(res.id);
      setFilteredOptions([...items, { id: res.id, value: res.value }]);
    } catch (error) {
      message.error('Failed to save new service option');
    }
  };

  const searchHandler = (value) => {
    setInputValue(value);

    const filtered = options.filter((opt) =>
      opt.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);

    setShowSaveOption(
      !options.some((opt) => opt.toLowerCase() === value.toLowerCase())
    );
  };

  const selectHandler = async (value) => {
    if (value === `save_${inputValue}`) {
      await saveOption(inputValue);
      setShowSaveOption(false);
      if (inputValue) handleSelect(inputValue, type);
    } else {
      handleSelect(value, type);
    }
  };

  const deleteHandler = async (event, value) => {
    try {
      await webServiceProvider.delete(`v1/vmrs-diagnosis/${shopId}/${value}`);

      handleDelete(value, type);

      setFilteredOptions((prev) => prev.filter((opt) => opt.id !== value));
    } catch (error) {
      message.error('Failed to save new service option');
    }
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>{title}</Col>
      </Row>
      <SelectRow>
        <Col span={23}>
          <Select
            showSearch
            onSearch={searchHandler}
            onSelect={selectHandler}
            value={value || undefined}
            defaultValue={undefined}
            filterOption={false}
            style={{ width: '100%' }}
            onChange={() => {}}
            optionLabelProp="label"
          >
            {filteredOptions.map((option) => (
              <Option key={option.id} value={option.id} label={option.value}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>{option.value}</span>
                  <CloseCircleFilled
                    style={{ fontSize: 12, marginLeft: 8, cursor: 'pointer' }}
                    onClick={(e) => deleteHandler(e, option.id)}
                  />
                </div>
              </Option>
            ))}
            {showSaveOption && inputValue && (
              <Option key={`save_${inputValue}`} value={`save_${inputValue}`}>
                <NewName>Save "{inputValue}"</NewName>
              </Option>
            )}
            {options}
          </Select>
        </Col>
      </SelectRow>
    </Container>
  );
}

export default C3Select;
